const e = "Premi Invio per modificare", t = {
  pressEnterToEdit: e
};
export {
  t as default,
  e as pressEnterToEdit
};
